import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

const Version = ({ collapsed }: { collapsed: boolean }) => {
  return (
    <>
      <Box
        sx={{
          padding: '10px',
        }}
      >
        <Stack
          alignItems={'center'}
          sx={{
            background: 'linear-gradient(343deg, #ffffff1c, #ffffff30)',
            flexDirection: 'column',
            borderRadius: '10px',
            p: '10px',
          }}
        >
          <img
            src="https://www.stagemporium.com/wp-content/themes/stagsemporium/images/logo.png"
            alt=""
            className="w-[35px] h-[35px] object-contain"
          />
          <Typography
            mt={'5px'}
            sx={{
              fontSize: collapsed ? '10px' : '',
            }}
          >
            Zoe App
          </Typography>
          <Typography
            sx={{
              fontSize: collapsed ? '8px' : '',
            }}
            variant={'caption'}
            color={'#dfdfdf'}
          >
            Version:{' '}
            {collapsed && (
              <>
                <br />
              </>
            )}{' '}
            1.0.0
          </Typography>
        </Stack>
      </Box>
    </>
  );
};
export default Version;
